<div [class]="style" (click)="navigate()">
    <div *ngIf="header" class="card-header">{{header}}</div>
    <div *ngIf="subheader" class="card-subheader">{{subheader}}</div>
    <div *ngIf="text"  class="card-text">{{text}}</div>
    <img *ngIf="image" [src]="image"  class="card-image">
</div>